













import Vue from "vue";
import Component from "vue-class-component";
import { mask } from "vue-the-mask";
import axios from 'axios';

@Component({
    directives: {
        mask,
    }
})
export default class DadosCepComplemento extends Vue {

    public cepMask = '#####-###';

    get cepComplemento () {
        return this.$store.state.cotacao.cep;
    }

    set cepComplemento ( value ) {
        this.$store.commit("SET_CEPCOMPLEMENTO", value);
    }

    get errorCepComplemento () {
        return this.$store.state.errors.cep;
    }

    public onChange () {
        this.$store.dispatch("VALIDAR_DADOS")
            .then()
            .catch(() => { return; });
    }
}
